import { cva } from 'class-variance-authority';

export const btnColorMap = {
  default: undefined,
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  accent: 'btn-accent',
  neutral: 'btn-neutral',
  info: 'btn-info',
  success: 'btn-success',
  warning: 'btn-warning',
  error: 'btn-error',
}

export const btnStyleMap = {
  default: undefined,
  soft: 'btn-soft',
  link: 'btn-link',
  ghost: 'btn-ghost',
  outline: 'btn-outline',
  dash: 'btn-dash',
};

export const btnSizeMap = {
  default: undefined,
  sm: 'btn-sm',
  lg: 'btn-lg',
};

export const buttonCva = cva(undefined, {
  variants: {
    color: btnColorMap,
    style: btnStyleMap,
    size: btnSizeMap,
  },
  compoundVariants: [
    {
      color: (Object.keys(btnColorMap) as Array<keyof typeof btnColorMap>).filter((key) => key !== 'default'),
      class: 'btn',
    },
    {
      style: (Object.keys(btnStyleMap) as Array<keyof typeof btnStyleMap>).filter((key) => key !== 'default'),
      class: 'btn',
    },
    {
      size: (Object.keys(btnSizeMap) as Array<keyof typeof btnSizeMap>).filter((key) => key !== 'default'),
      class: 'btn',
    },
  ],
});
